import React, { Component } from "react";
import Panel from "../../../UI/Panel";
import PageSubTitle from "../../../UI/PageSubTitle";
import Button from "../../../UI/Button";
import Textarea from "../../../UI/Textarea";
import PanelBody from "../../../UI/Panel/PanelBody";

export default class ProfileQuickMessage extends Component {
  state = { message: "" };
  render() {
    const { message } = this.props;
    return (
      <Panel>
        <PanelBody>
          <PageSubTitle>
            <h3>Quick Message</h3>
          </PageSubTitle>
          <div className="form-group">
            <Textarea
              value={message}
              onChange={value => {
                this.setState({ message: value });
              }}
            />
          </div>
          <Button
            label="Send"
            className="pull-right"
            disabled={message === "" ? true : false}
            success
            small
          />
        </PanelBody>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/ProfileQuickMessage/index.js